<template>
    <div id="firebaseui-auth-container"></div>
</template>

<script>
    import TokenManager from "@/api/tokenManager/TokenManager"
    import * as firebaseui from 'firebaseui'
    import {apiClient} from "@/api"; 
    import i18n from '@/i18n';

    export default {
        name: "social-login",
        components : {
        },
        data: function() {
            return {
                firebaseUI: null,
                tokenManager: new TokenManager(),
                firebase: null,
                providers: []
            }
        },
        methods: {
            firebaseUiConfig() {
                return {
                    signInOptions: this.providers,
                    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
                    signInFlow: "popup",
                    tosUrl: i18n.t('auth.social.tos_url'),
                    privacyPolicyUrl: function() {
                        window.location.assign(i18n.t('auth.social.tos_url'));
                    },
                    callbacks: {
                        signInSuccessWithAuthResult: () => {
                            return false
                        },
                    }
                };
            },
            initFirebaseUI() {
                if(!firebaseui.auth.AuthUI.getInstance()) {
                    this.firebaseUI = new firebaseui.auth.AuthUI(this.firebase.auth());
                }
                this.firebaseUI = firebaseui.auth.AuthUI.getInstance()
                this.firebaseUI.start('#firebaseui-auth-container', this.firebaseUiConfig());

                this.providers.forEach(({key, provider}) => {
                    let button = document.querySelector(`[data-provider-id="${provider}"] .firebaseui-idp-text-long`)
                    if (button) {
                        button.innerHTML = this.$t(`auth.provider.${key}`)
                    }
                })
            }
        },
        mounted () {
            this.firebase = this.tokenManager.getFirebaseSDK()
            this.providers = [
                { 'key': 'google', 'provider': this.firebase.auth.GoogleAuthProvider.PROVIDER_ID },
                { 'key': 'facebook', 'provider': this.firebase.auth.FacebookAuthProvider.PROVIDER_ID }
            ]
            this.initFirebaseUI();

            const me = this
            this.firebase.auth().onAuthStateChanged(function(user) {
                if (user && !user.isAnonymous) {
                    apiClient.requestForTokenRefresh().then(() => {
                        return apiClient.skitudeRegisterCheckEmail(user.email)
                    }).then((response) => {
                        if (!response.data.object.exists) {
                            console.log('NEW user, proceed to register')
                            me.$emit('startRegister')
                            return
                        }

                        me.$emit('loggedIn')
                    })
                } else {
                    console.error('isAnonymous', user.isAnonymous)
                }
            }, function(error) {
                console.log("error on login in firebase", error);
                const event = new CustomEvent('errorModal', {
                    detail: {
                        body: i18n.t('auth.login.error')
                    } 
                });
                window.dispatchEvent(event)
            })
        }
    };
</script>

<style scoped>

</style>

